// labMaster.js — lab master data copied from the Excel sheets (container tare weights, CBR mould weights).
// Enter a number, get the weight. Edit here when a container/mould is added or re-weighed (date it in the commit).
// Lookups are EXACT: an unknown number returns null (the Excel LOOKUP() silently picked the nearest lower row).

// 'MDD' sheet, K20:L119 — containers used for the compaction moisture samples
export const MDD_CONTAINERS = {
  1: 98.64, 2: 101.82, 3: 83.92, 4: 91.52, 5: 74.62, 6: 91.62, 7: 85.36, 8: 94.27, 9: 86.93, 10: 74.73,
  11: 92.14, 12: 102.34, 13: 131.51, 14: 73.62, 15: 107.23, 16: 95.36, 17: 94.56, 18: 88.64, 19: 86.79,
  20: 87.96, 21: 95.36, 22: 134.5, 23: 134.2, 24: 135.2, 25: 95.6, 26: 101.24, 27: 147, 28: 133.8,
  29: 135.54, 30: 134.58, 31: 134.62, 32: 85.62, 33: 102.34, 34: 136.42, 35: 137.45, 36: 125.63, 37: 122.31,
  38: 124.5, 39: 95.36, 40: 76.13, 41: 134.5, 42: 134.2, 43: 134.5, 44: 140, 45: 136.5, 46: 137, 47: 138.8,
  48: 74.48, 49: 136.6, 50: 139.2, 51: 134.5, 52: 139, 53: 137.2, 54: 136.4, 55: 129.8, 56: 141.1, 57: 140.8,
  58: 141.3, 59: 139.6, 60: 139.9, 61: 138.5, 62: 137.6, 63: 138.2, 64: 136.4, 65: 138, 66: 137.9, 67: 139.5,
  68: 140, 69: 140.5, 70: 138.9, 71: 137.6, 72: 137, 73: 137.2, 74: 136.2, 75: 136, 76: 136, 77: 139.5,
  78: 141, 79: 140.8, 80: 140.7, 81: 141, 82: 141.1, 83: 139.2, 84: 138.7, 85: 136.5, 86: 136.4, 87: 138.8,
  88: 139, 89: 141.2, 90: 132.52, 91: 136.4, 92: 139.4, 93: 128.4, 94: 143.2, 95: 129.8, 96: 154.2,
  97: 155.6, 98: 139.7, 99: 145.2, 100: 143.6,
};

// 'CBR Summary' sheet, J12:K84 — containers used for the CBR moisture samples
export const CBR_CONTAINERS = {
  1: 84.2, 2: 88.9, 3: 75.74, 4: 89.8, 5: 142.8, 6: 81.6, 7: 90.5, 8: 85.3, 9: 74.68, 10: 145.6, 11: 139.6,
  12: 133.7, 13: 139.3, 14: 137.9, 15: 73.25, 16: 137.6, 17: 127.3, 18: 138.3, 19: 134.3, 20: 146.5,
  21: 141.3, 22: 138.5, 23: 137.4, 24: 129, 25: 138.5, 26: 136.4, 27: 129.8, 28: 141.1, 29: 140.8, 30: 141.3,
  31: 139.6, 32: 139.9, 33: 138.5, 34: 137.6, 35: 138.2, 36: 136.4, 37: 74.46, 38: 72.34, 39: 139.5, 40: 140,
  41: 140.5, 42: 72.31, 43: 137.6, 44: 73.11, 45: 137.2, 46: 72.36, 47: 136, 48: 136, 49: 139.5, 50: 141,
  51: 140.8, 52: 140.7, 53: 141, 54: 141.1, 55: 139.2, 56: 138.7, 57: 136.5, 58: 136.4, 59: 138.8, 60: 139,
  61: 141.2, 62: 132.52, 63: 136.4, 64: 139.4, 65: 128.4, 66: 143.2, 67: 129.8, 68: 154.2, 69: 155.6,
  70: 139.7, 71: 145.2, 72: 139.7, 73: 145.2,
};

// 'CBR Summary' sheet, N12:O69 — CBR mould weights (g)
export const MOULD_WEIGHTS = {
  1: 7161, 2: 6775, 3: 6552, 4: 6978, 5: 6981, 6: 6819, 7: 6552, 8: 6981, 9: 6789, 10: 6909, 11: 6789,
  12: 6819, 13: 6935, 14: 6674, 15: 6778, 16: 6848, 17: 6956, 18: 7245, 19: 6984, 20: 7054, 21: 6797,
  22: 6676, 23: 6987, 24: 6967, 25: 6795, 26: 6969, 27: 6854, 28: 6916, 29: 6690, 30: 6789, 31: 6534,
  32: 6822, 33: 6738, 34: 6990, 35: 6753, 36: 6753, 37: 6684, 38: 7752, 39: 7780, 40: 7767, 41: 7792,
  42: 8173, 43: 8009, 44: 7774, 45: 8104, 46: 7797, 47: 7992, 48: 8025, 49: 7958, 50: 7768, 51: 7924,
  52: 7705, 53: 7836, 54: 7793, 55: 7945, 56: 7826, 57: 8015, 58: 7958,
};

const get = (table, no) => {
  const k = Number(no);
  return no !== '' && no != null && Number.isInteger(k) && table[k] != null ? table[k] : null;
};
export const mddContainerG = (no) => get(MDD_CONTAINERS, no);
export const cbrContainerG = (no) => get(CBR_CONTAINERS, no);
export const mouldG = (no) => get(MOULD_WEIGHTS, no);

// yyyy-mm-dd + days -> yyyy-mm-dd (UTC safe, no timezone drift)
export const addDays = (iso, days) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  const t = new Date(Date.UTC(y, m - 1, d + days));
  return t.toISOString().slice(0, 10);
};
